import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EditorColorService } from '../../_services';
import { ColorSwatchPickerComponent } from './color-swatch-picker.component';

// Makes a <app-color-swatch-picker appEditorColorPicker> the picker TinyMCE color buttons open while its screen is alive.
// Place one on screens with rich text editors (OMP sidebar, Step Builder) instead of in every editor component.
@Directive({
  selector: '[appEditorColorPicker]',
})
export class EditorColorPickerDirective implements OnInit, OnDestroy {
  private subscription = new Subscription();

  constructor(private picker: ColorSwatchPickerComponent, private editorColorService: EditorColorService) {}

  ngOnInit() {
    this.picker.hideTrigger = true;
    this.editorColorService.register(this.picker);
    this.subscription.add(this.picker.colorChange.subscribe((color: string) => this.editorColorService.apply(color)));
    this.subscription.add(this.picker.removed.subscribe(() => this.editorColorService.remove()));
    this.subscription.add(this.picker.closed.subscribe((keepColor: boolean) => this.editorColorService.close(keepColor)));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.editorColorService.unregister(this.picker);
  }
}
